import { RouteAddress } from './route-address.model';
import { RoutePosition } from './route-position.model';

export class RouteResultsModel {
    public address: RouteAddress;
    public position: RoutePosition;
}
